import { Sizes, Text } from '@sede-enterprise/shell-ds-react-framework';
import {
  LegendColor,
  LegendItem,
  LegendWrapper,
} from 'components/Charting/Legend/Legend.styled';
import {
  AllTradeMarkets,
  ColorMap,
} from 'pages/Optimisation/components/ContractedVolume/types';
import { CHART_CONSTANTS } from 'pages/Optimisation/constants';

type Identifier = AllTradeMarkets | 'disabled' | 'other';

type LegendProps = {
  colorMap: ColorMap;
  items: {
    label: string;
    identifier: Identifier;
    market: string;
  }[];
  onLegendItemClick?: (identifier: string) => void;
};

type UniqueLabel = string;
type BackgroundColor = string;

const Legend = ({ colorMap, items, onLegendItemClick }: LegendProps) => (
  <LegendWrapper>
    {Array.from(
      items.reduce((acc, { label, identifier, market }) => {
        const backgroundColor =
          colorMap[market][identifier] || CHART_CONSTANTS.fallbackColor;

        return acc.set(label, { backgroundColor, identifier });
      }, new Map<UniqueLabel, { backgroundColor: BackgroundColor; identifier: Identifier }>()),
    ).map(([label, { backgroundColor, identifier }]) => (
      <LegendItem
        key={`${label}`}
        onClick={() => onLegendItemClick?.(identifier)}
      >
        <>
          <LegendColor
            style={{ backgroundColor }}
            data-testid="legend-item-color"
          />
          <Text data-testid="legend-item-text" size={Sizes.Small}>
            {label}
          </Text>
        </>
      </LegendItem>
    ))}
  </LegendWrapper>
);

export default Legend;
